export const tableActionForUpdatingSelects = ['sort', 'search', 'onSearchClose', 'filterChange', 'changePage'];
export const ROWS_PER_PAGE_BY_DEFAULT = 10;
export const CURRENT_PAGE_BY_DEFAULT = 0;
export const ROWS_PER_PAGE_OPTIONS_DEFAULT = [10, 50, 100, 250, 500];

export const DEFAULT_MAX_DOCUMENTS_TO_DOWNLOAD = 10;

export const SELECTED_ROW_HIGHLIGHT_CLASS = 'selected-table-row-highlight';

export default undefined;